<template>
    <div  class="taskDetail" v-if="taskInfo"  id="taskDetail">
        <!-- 任务 封面 详情 -->
        <div class="top-container" v-if="!resourceName">
            <div class="bg-image-box"></div>
            <img :src="taskInfo.coverUrl" class="bg-image" alt="">
            <span @click="goBack" class="arrow-icon-box">
                <svg-icon icon-class="arrow-icon" ></svg-icon>
            </span>
            <div class="taskDetail-content" v-if="taskInfo.name" @click="handQuicklyStudy">
                <img class="coverUrl" :src="taskInfo.coverUrl" alt="">
                <div class="taskDetail-content-right">
                    <h4 class="title">{{taskInfo.name}}</h4>
                    <p class="label">
                        <span class="label1" v-if="taskInfo.vocation">{{taskInfo.vocation.vocationName}}</span>
                        <span class="label2" v-if="taskInfo.workType">{{taskInfo.workType.vocationName}}</span>
                        <span class="label3" v-if="taskInfo.skillLevel">{{taskInfo.skillLevel.vocationName}}</span>
                    </p>
                    <p class="study-length _clear" v-if="taskInfo.courseNum>0"><img src="../../../assets/images/learning/time1.png" alt="">学习时长{{taskInfo.learnTotalTime | formateTime}}小时 <span>|</span>已完成{{ taskInfo.studyProcess || 0}}%</p>
                    <p class="mission-cycle" v-if="is_taskTime">任务周期：{{taskInfo.cycleType!==3?formatTime1(taskInfo.startTime)+' ~ '+formatTime1(taskInfo.endTime):'长期有效'}}</p>
                </div>
            </div>
        </div>
        <!-- 播放器 -->
        <div class="course-play" v-show="resourceName">
            <div class="course-top">
                <span @click="goBack" class="arrow-icon-box">
                    <svg-icon icon-class="arrow-icon" ></svg-icon>
                </span>
                <p class="name">{{resourceName}}</p>
                <!-- 安卓手机 清晰度切换 -->
                <ul class="clarityStyle" v-if="isAndroid && currentlyPlay && [1].includes(+currentlyPlay.type)">
                    <li class="fr currently" @click="() => { this.clarityShow = !this.clarityShow }">{{clarity[videoInfo.videoClarity].val}}</li>
                    <li v-show="clarityShow" class="fr" @click="cutoverClarity(item.key)" v-for="(item, index) in clarity" :key="index">{{item.val}}</li>
                    <li class="clear"></li>
                </ul>
            </div>
            <div style="min-height:210px">
                <!-- 课程播放 -->
                <coursePlay ref="Aliplayer" @ended="playEnd" @play="startPlay" @pause="playPause" @timeupdate="timeupdatePlay" :currentlyPlay="currentlyPlay" :isDoubleSpeed="+isDoubleSpeed" :isDraw="+isDraw" :TrainBasicInfo="TrainBasicInfo" :videoInfo="videoInfo" v-if="currentlyPlay"></coursePlay>
            </div>
        </div>
        <!-- tab 切换 简介 目录 -->
        <div class="taskDetail-tab">
            <p class="tab-item" :class="{'tabActive':tabActive === item.id}"  v-for="item in tabList" :key="item.id" @click="tabClick(item)">{{item.name}}</p>
        </div>
        <!-- 简介 -->
        <div class="task-description" v-if="tabActive === 1">
            <p v-html="taskInfo.description" class="description"></p>
        </div>
        <!-- 大纲树 -->
        <div class="task-tree">
            <taskTree v-if="tabActive === 2" :currentlyPlay="currentlyPlay" :TrainBasicInfo="TrainBasicInfo" :courseInfo="courseInfo" :taskInfo="taskInfo" ref="taskTree" :list="taskList"></taskTree>
        </div>
        <!-- 快速学习按钮 -->
        <div class="quicklyStudyButton" v-if="currentlyPlay"  @click="handQuicklyStudy">
            <p :style="`background-color: ${buttomButtonColor};`">{{QuicklyStudyInfo && QuicklyStudyInfo.learnRate ? '继续学习' :'开始学习'}}</p>
        </div>
        <!-- 人脸识别弹窗 -->

        <facedialog ref="facedialog" v-if="isfacedialog" :isfacedialog="isfacedialog" :nodeId="nodeId" :resourceId="resourceId" :courseId="courseId" :businessId="courseId"  @close="closeFacedialog" :businessType="1" :courseBeforeAndAfterType="+courseBeforeAndAfterType" :taskId="+$route.query.id"></facedialog>
        <!-- 提示 倒计时弹窗 -->
        <van-dialog class="coursedialog" v-model="courseshow" :show-confirm-button="false">
            <div class="coursedialog-content">{{coursetxt}}</div>
            <van-button class="coursedialog-btn" @click="courseshow = false">知道了（{{djscount}}S后关闭）</van-button>
        </van-dialog>
        <!-- 培训任务提示内容 -->
        <van-dialog class="coursedialog" v-if="isTaskTipShow" v-model="isTaskTipShow" :show-confirm-button="false">
            <div class="coursedialog-content">{{TrainBasicInfo.syllabusHintContent}}</div>
            <van-button class="coursedialog-btn" @click="isTaskTipShow = false">知道了</van-button>
        </van-dialog>
    </div>
    <div v-else>
        <van-overlay :show="showLoading"/>
        <div class="loadinglist">
            <van-loading v-if="showLoading" size="24px" vertical>加载中...</van-loading>
        </div>
    </div>
</template>

<script>
import taskTree from './taskTree.vue'
import coursePlay from '../../course/page/playNew.vue';
import facedialog from './../../../layout/facedialog.vue'; // 人脸识别
import { goLiveHome } from './../../../utils/livePlatform'; // 直播跳转
import $ from 'jquery';
export default {
    name:'taskDetail',
    components:{taskTree,coursePlay,facedialog},
    data(){
        return {
            showLoading:true,
            isTaskTipShow:false,
            tabActive:2,
            tabList:[
                {
                    id:1,
                    name:'简介'
                },
                {
                    id:2,
                    name:'目录'
                }
            ],
            taskList:[],
            courseshow:false, // 弹窗 2秒关闭 课程未开启
            coursetxt:'', // 文案
            djscount:2,
            nodeId:null, // 节点id  人脸识别成功之后需要
            resourceId:null, // 课程资源id 人脸识别成功之后需要
            taskInfo:null,
            isHaveLive:false, // 直播 浏览器地址文案
            currentlyPlay:null, // 当前视频音频播放信息
            isDraw:0, // 视频是否拖拽
            isDoubleSpeed:0,
            videoInfo:{ // 视频音频信息
                videoType: {
                    format: 'mp3',
                    mediaType: 'audio'
                },
                videoClarity: 'SD',
                source:{},
                detect: true,
                deadline: 0,
                index: 0,
                fastForward:false,
                url: [],
            },
            IntervalName:null,// 定时器 保存视频进度
            timeoutDialogAlert:null,// 视频设置弹窗
            faceRecognizeTimer:null,// 人脸识别定时器
            saveLogtime:15, // 保存接口 定时器时间
            TrainBasicInfo:null, // 任务规则
            isfacedialog: false, // 人脸识别弹窗
            endedStatue:true,// 视频播放结束标时
            sourceId:0,// 课程当前
            isAndroid: false, // 是否是安卓手机
            clarityShow:false,
            courseId:null,// 当前播放课程ID
            resourceName:'',// 当前观看的资源名称
            courseInfo:{}, // 课程详情
            courseBeforeAndAfterType:'',
            clarity: {
                LD: {
                    key: 'LD',
                    val: '标清'
                },
                SD: {
                    key: 'SD',
                    val: '高清'
                }
            },
            studyProcess:0,// 课程学习进度
            allresouce:[], // 课程大纲扁平化
            QuicklyStudyInfo:null,
            buttomButtonColor:'',
            isCloseFacedialog:false,// 人脸识别弹出 关闭人脸识别
            task_course_after_faceIdentification:false,// 视频播放后人脸识别
            course_after_faceIdentification_time:15,//课后人脸识别弹出时间
            is_taskTime:true,
            Task_interface_optimize:false
        }
    },
    watch:{
        courseshow: {
            handler(n) {
                if(n===true && this.djscount>0){
                    let clear=setInterval(()=>{
                        this.djscount--;
                        if(this.djscount<=0){
                            this.courseshow=false;
                            console.log('倒计时弹窗')
                            clearInterval(clear);
                        }
                    },1000);
                }
            },
            immediate: true
        },
    },
    filters: {
        formateTime: function(val) {
            return val ? (val / 3600).toFixed(2) : val;
        }
    },
    async created(){
        console.log('createdcreatedcreatedcreated')
        $(window).scrollTop(0);
        this.initConfig();
        const u = navigator.userAgent;
        this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    },
    async mounted(){
        
        console.log(this.showLoading,'showLoading')
        await this.findTaskRule();
        await this.getQuicklyStudyInfo();
        if(this.Task_interface_optimize){
          await this.taskDetailWithoutLogin();
        }else{
          await this.getTaskDetail();
        }
        
        // 首次进入
        if(this.TrainBasicInfo.openSyllabusHintSwitch && this.TrainBasicInfo.hintCycle === 1 && this.$route.query.isNewTask == 'true'){
            this.isTaskTipShow = true;
        }
        // 每次进入弹出提示
        if(this.TrainBasicInfo.openSyllabusHintSwitch && this.TrainBasicInfo.hintCycle === 2 && !this.$route.query.isFacePage && this.$route.query.ishint == '1'){
            this.isTaskTipShow = true;
        }
        if (window.history && window.history.pushState) {
          // 往历史记录里面添加一条新的当前页面的url
          history.pushState(null, null, document.URL);
          // 给 popstate 绑定一个方法 监听页面刷新
          window.addEventListener("popstate", this.goBack, false); //false阻止默认事件
        }

        // 获取用户信息
        this.getAccountUserInfo();
        // 人脸识别需要
        if (this.$route && +localStorage.getItem("firstfaceauth") === 1) {
            localStorage.setItem("firstfaceauth", 0)
            localStorage.setItem("faceidentify", 1)
            this.$router.replace({ path: this.$route.path, query: { ...this.$route.query, mark: Math.random() } })
        }
        if(+sessionStorage.getItem('videoEndFace') !== 1){ // 0 需要
            sessionStorage.setItem('videoEndFace',0)
        }

        setTimeout(function(){
            if(localStorage.getItem('type')=='iOS'){
                if(localStorage.getItem('statusBarHeight')){ // 是在iOS内
                    document.getElementById('taskDetail').style.paddingTop= localStorage.getItem('statusBarHeight') +'px'
                    document.getElementById('taskDetail').style.boxSizing='border-box'
                }
            }
        },600)
    },
    methods:{
        async initConfig(){
          const frontendConfigArr = (sessionStorage.getItem('frontendConfig') && JSON.parse(sessionStorage.getItem('frontendConfig'))) || this.$store.state.dynamic.frontendConfig || [];
          const buttomButtonColor = frontendConfigArr.length && frontendConfigArr.filter(item => {
              if(item.key === 'task_bottom_start_button_color'){
                  return true
              }
          })[0];
          const task_course_after_faceIdentification = frontendConfigArr.length && frontendConfigArr.filter(item => {
              if(item.key === 'task_course_after_faceIdentification'){
                  return true
              }
          })[0];
          const saveLogtime = frontendConfigArr.length && frontendConfigArr.filter(item => {
              if(item.key === 'course_saveLog_time'){
                  return true
              }
          })[0];
          const is_taskTime = frontendConfigArr.length && frontendConfigArr.filter(item => {
              if(item.key === 'is_taskTime'){
                  return true
              }
          })[0];
          const course_after_faceIdentification_time = frontendConfigArr.length && frontendConfigArr.filter(item => {
              if(item.key === 'course_after_faceIdentification_time'){
                  return true
              }
          })[0];
          let Task_interface_optimize = frontendConfigArr.length && frontendConfigArr.filter(item => {
              if(item.key === 'Task_interface_optimize'){
                  return true
              }
          })[0];
          this.Task_interface_optimize = Task_interface_optimize.value && Task_interface_optimize.value === 'true' ? true : false;
          this.course_after_faceIdentification_time = (course_after_faceIdentification_time && course_after_faceIdentification_time.value) || 15

          this.is_taskTime = is_taskTime && is_taskTime.value === 'true' ? true : false;
          this.saveLogtime = (saveLogtime && saveLogtime.value) || 15;
          this.buttomButtonColor = (buttomButtonColor && buttomButtonColor.value ) || '#316FFF'
          this.task_course_after_faceIdentification = task_course_after_faceIdentification && task_course_after_faceIdentification.value == 'true' ? true : false;
        },
        // 点击培训任务封面和开始学习按钮 进行播放
        handQuicklyStudy(){
            console.log(this.currentlyPlay,'currentlyPlay')
            if(this.currentlyPlay){
                // init：初始化。
                // ready：准备。
                // loading：加载中。
                // play：播放。
                // pause：暂停。
                // playing：正在播放。
                // waiting：等待缓冲。
                // const arr = ['init','ready','loading','play','pause','playing','waiting']
                // if(this.$refs.Aliplayer.player && arr.includes(this.$refs.Aliplayer.player.getStatus())){
                //     console.log(this.$refs.Aliplayer.player.getStatus(),'this.$refs.Aliplayer.player.getStatus')
                //     return false;
                // }
                this.clickNode(this.currentlyPlay)
            }else {
                this.$toast('暂无课程');
            }
        },
        formatTime1(val) {
            if(val){
                return val.split(' ')[0].split('-').join('.');
            }
        },
        async getQuicklyStudyInfo(){
            const taskType = 2
            await this.$api.learning.quicklyStudy(this.$route.query.id,taskType).then( res => {
                console.log(res.data)
                if(res.data){
                    this.QuicklyStudyInfo = res.data;
                    if(!this.$route.query.nodeId){
                        this.nodeId = res.data.lastPlayItemId;
                    }
                }

            })
        },
        /** tab切换 */
        tabClick(item){
            this.tabActive = item.id;
        },
        /** 返回 */
        goBack(){
            console.log('back')
            /**
             * 离开页面之前视频播放过程中保存进度
             */
            let video = document.querySelector('video')
            console.log(this.currentlyPlay,'this.currentlyPlay')
            if (this.currentlyPlay && (+this.currentlyPlay.type === 2 || +this.currentlyPlay.courseType === 2)) {
                video = document.querySelector('audio')
            }
            if(video){
                this.postCourseLearningLogSaveLog();
                this.postUserLearningLog();
            }
            // this.$router.go(-1)
            if(this.$route.query.usego) {
                if(this.$isapp && this.$publicFn.getUserAgent(false) != 'h5') {
                    return this.$WDJSBridge.useBack()
                }
                this.$router.go(-1);
                return false;
            }
            if(this.$route.query.backPath){
                this.$router.push({
                    path: this.$route.query.backPath,
                    query: {
                        goodsId:this.$route.query.goodsId,
                        goodsKind:this.$route.query.goodsKind,
                        distributionUserId:this.$route.query.distributionUserId,
                    }
                })
            }else{
                this.$router.push({
                    name: "learning",
                    query:{
                        backType:this.$route.query.backType || 1,
                    }
                });
            }
        },
        getTaskLockText(){
            if(this.taskInfo.lockCourseRate && this.taskInfo.lockExamCondition===1 && this.taskInfo.isFormCommit){
                this.coursetxt='该章未开启，开启条件为前面的学习内容学习进度达到'+this.taskInfo.lockCourseRate+'%，考试及格，表单提交';
            }else if(this.taskInfo.lockCourseRate && this.taskInfo.lockExamCondition===0 && this.taskInfo.isFormCommit){
                this.coursetxt='该章未开启，开启条件为前面的学习内容学习进度达到'+this.taskInfo.lockCourseRate+'%，表单提交';
            }else if(!this.taskInfo.lockCourseRate && this.taskInfo.lockExamCondition===0 && this.taskInfo.isFormCommit){
                this.coursetxt='该章未开启，开启条件为表单提交';
            } else if(!this.taskInfo.lockCourseRate && this.taskInfo.lockExamCondition===1 && !this.taskInfo.isFormCommit ){
                this.coursetxt='该章未开启，开启条件为考试及格';
            } else if(this.taskInfo.lockCourseRate && this.taskInfo.lockExamCondition===0 && !this.taskInfo.isFormCommit){
                this.coursetxt='该章未开启，开启条件为前面的学习内容学习进度达到'+this.taskInfo.lockCourseRate+'%';
            } else if(this.taskInfo.lockCourseRate && this.taskInfo.lockExamCondition && !this.taskInfo.isFormCommit ){
                this.coursetxt='该章未开启，开启条件为前面的学习内容学习进度达到'+this.taskInfo.lockCourseRate+'%，考试及格';
            } else if(!this.taskInfo.lockCourseRate && this.taskInfo.lockExamCondition && this.taskInfo.isFormCommit){
                this.coursetxt='该章未开启，考试及格，表单提交';
            }
            this.djscount=2;
            this.courseshow=true;
            return;
        },
        /**
         * 定位打开 节点
         */
        /* eslint-disable */
        familyTree (arr1, id, tag,end) {
            let temp = []
            const that = this;
            let forFn = function (arr, id) {
                for (let i = 0; i < arr.length; i++) {
                    let item = arr[i];
                    if (item.id === id) {
                        temp.push(item)
                        if(item.childItemList && item.childItemList.length){
                            // item.isShow = true;
                            that.$set(item,'isShow',true)
                        }
                        forFn(arr1, item.parentId,tag)
                        break
                    } else {
                        if (item.childItemList) {
                            forFn(item.childItemList, id,tag)
                        }
                    }
                    if(tag){
                        // 获取人脸识别成功 当前节点
                        if(item.id === (+that.nodeId || +that.$route.query.nodeId )){
                            if(item.courseType){
                                that.currentlyPlay = item;
                                // 播放完毕不需要自动点击
                                if(end !== 'end'){
                                  if(that.$route.query.nodeId && [1,2].includes(item.courseType)){
                                      that.clickNode(that.currentlyPlay)
                                  }
                                }

                                console.log(that.currentlyPlay,'that.currentlyPlay===')
                                return false;
                            }
                        }
                    }
                }
            }
            forFn(arr1, id);
            this.$forceUpdate();
            return temp;
        },
        /**
         * 关闭人脸识别弹窗
         */
        closeFacedialog (val) {
            $('.faceconfirm').remove();
            console.log('faceconfirm=====')
            this.isCloseFacedialog = true;
            this.isfacedialog = val;
        },
        /**
         * 安卓手机 清晰度切换
         */
        async cutoverClarity (clarity) {
            if(this.$refs.Aliplayer.player && this.$refs.Aliplayer.player.getCurrentTime()){
                this.currentlyPlay.studyInfo = {}
                this.currentlyPlay.studyInfo.playLength = this.$refs.Aliplayer.player.getCurrentTime();
            }
            await this.playerDispose();
            this.clarityShow = false;
            this.videoInfo.videoClarity = clarity || this.videoInfo.videoClarity;
            const bool = (this.videoInfo?.source?.sourceSing && (this.videoInfo?.source?.sourceSing=='222' || this.videoInfo?.source?.sourceSing=='333'))?true:false;
            await this.$refs.Aliplayer.getAliplayer(this.videoInfo.source, bool,this.videoInfo);
        },
        /**
         * 课程详情
         */
        async getCourseInfo(item){
            let params = {
                courseId:item && (item.contentId || item.courseId) || this.courseId || this.$route.query.courseId,
                taskId:this.$route.query.id,
                taskType:2
            }
            await this.$api.course.findCourseInfo({params}).then(res => {
                this.courseInfo = res.data;
                console.log(this.courseInfo,'this.courseInfo')
                if(!res.data.userLearnInfo){
                    this.studyProcess = 0
                }else{
                    this.studyProcess = res.data.userLearnInfo.learnRate || 0
                }
            })
        },
        /**
         * 获取任务规则信息
         */
        async findTaskRule () {
            const params = {
                taskId: this.$route.query.id || ''
            }
            await this.$api.learning.findTaskRule({ params }).then( res => {
                this.TrainBasicInfo = res.data;
                console.log(this.TrainBasicInfo,'TrainBasicInfo父组件')
                this.isDraw = res.data.isDraw;
                console.log(this.isDraw,'isDraw')
                this.isDoubleSpeed = res.data.isDoubleSpeed;
            })
        },
            // 定时器
        async timing () {
            let video = document.querySelector('video')
            if (+this.currentlyPlay.type === 2 || +this.currentlyPlay.courseType === 2) {
                video = document.querySelector('audio')
            }
            const saveLogtime = +this.saveLogtime * 1000;
            console.log(saveLogtime,'saveLogtime===')
            this.IntervalName = setInterval(async () => {
                console.log('savelog 定时器')
                if(video && video.duration){
                    this.postCourseLearningLogSaveLog();
                    this.postUserLearningLog();
                }

            }, saveLogtime);
            // return this.IntervalName
        },
        judgeNaN (value) {
         return (typeof value) === 'number' && window.isNaN(value);
        },
        /**
         * 保存进度
         */
        async postCourseLearningLogSaveLog () {
            let video = document.querySelector('video')
            if (+this.currentlyPlay.type === 2 || +this.currentlyPlay.courseType === 2) {
                video = document.querySelector('audio')
            }
            let isNaN = this.judgeNaN(video.currentTime) || this.judgeNaN(video.duration);
            if(isNaN){
              return false;
            }
            let cur = '',max = '';
            if(video){
              cur = video.currentTime && video.currentTime > 0 ? video.currentTime : 1;
              max = video.duration && video.duration > 0 ? video.duration : 1;
            }

            /**
             * saveLogtime 配置的秒数
             * 如果进度小于saveLogtime秒，直接保存总进度
             */
            if((video?.duration - video?.currentTime) <= (+this.saveLogtime+5)){
                cur = video.duration;
            }
            if( cur > 1){
                // 实时存储进度条变化
                localStorage.setItem('videoTime',cur);
            }

            const data = {
                courseId:this.courseId,
                taskId: this.$route.query.id || '',
                taskType:2,
                courseItemId: this.currentlyPlay.id,
                cur, // 当前进度
                max, // 总时长
                pollingTime: this.saveLogtime || 15
            }
            // for (let key in data) {
            //     if (!data[key]) {
            //     console.log(key, '---key---', data[key])
            //     }
            // }
            return await this.$api.course.postCourseLearningLogSaveLog({ data }).then(res => {
                console.debug(res)
            }).catch(err => {
                console.log(err,'err')
            })
        },
        /**
         * 记录当前用户的学习时长
         */
        async postUserLearningLog () {
            const data = { learningLength: this.saveLogtime || 15 };
            return this.$api.course.postUserLearningLog({ data });
        },
        // 实名认证与人脸识别
        async judgefaceauth (type) {
            console.log(this.isfacedialog,'isfacedialog----judgefaceauth')
            // 如果video 进入全屏状态则退出全屏
            if(this.checkIsFullScreen()){
                this.exitFullscreen();
            }
            if (+this.TrainBasicInfo.isCourseFaceRecognize === 1 && +localStorage.getItem("firstfaceauth") === 0) {
                this.courseBeforeAndAfterType = type;
                 this.isfacedialog = true;
                this.$forceUpdate()
            }
        },
        // 考试
        toexamDetial(item) {
            this.$router.push({
                path: '/examlistDetails',
                query: {
                    trainId: item.taskId,
                    contentId: item.contentId,
                    trainItemExamId: item.contentId,
                    type:2,
                    backType:this.$route.query.backType || 1,
                    backPath: this.$route.query.backPath,
                    goodsId:this.$route.query.goodsId,
                    goodsKind:this.$route.query.goodsKind,
                }
            })
        },
        // 直播
        watchLivejump(contentId, status, item){
            if(status == 0 || status == 1){ //
                goLiveHome(this, contentId,item)
              } else {
                this.$toast({
                    message:'直播已结束！',
                    duration: 3000,
                });
                return false
            }
        },
        /**
         * 单击节点
         */
        async clickNode(item,tag){
            console.log('节点===');
            if(item.homeworkId){
                // 作业
                this.$router.push({
                    path: '/homeworkDetail',
                    name: 'homeworkDetail',
                    query: {
                        courseId: item.courseId,
                        status: item.status?item.status:1,
                        homeworkId: item.homeworkId,
                        taskId: this.$route.query.id
                    }
                })
                return false;
            }
            // 课程上锁
            // 任务上锁
            if(item.isLocked){
                if(item.type && item.type !== 8){
                    this.getTaskLockText();
                    return;
                }else if(item.courseType){
                    this.coursetxt='该章未开启';
                    this.djscount=2;
                    this.courseshow=true;
                    return;
                }

            }
            // 任务
            if(item.type){
                // 清除任务设置课程弹屏
                clearInterval(this.timeoutDialogAlert);
                // 清除 人脸识别定时器
                clearInterval(this.faceRecognizeTimer);
                // 线下实训
                if(item.type === 1 && item.isTraining ) {
                    if(!item.isTrainingCanReserve) {
                        if(item.trainingResult !== 1) { // 成绩不合格
                            this.$toast({
                                message: '正式考核通过后可预约',
                                position: 'middle'
                            })
                            return
                        }else {
                            return
                        }
                    }
                    this.$router.push({
                        path: '/subscribeList',
                        query: {
                            taskId: item.taskId,
                            searchKey: '',
                        }
                    })
                    return
                }
                if(item.type === 2){ // 课程
                    if(item.contentId == this.courseId || (!this.courseId && typeof(this.courseId) != 'undefined')){
                        this.courseId = item.contentId;
                    }
                    // 课程详情
                    await this.getCourseInfo(item);
                    if ( this.courseInfo.dateExpireStatus == 2) {
                        this.$notify({
                            type: "warning", message: "已过期不可查看",
                        });
                        return;
                    }

                }else if(item.type===3){ // 考试
                    this.toexamDetial(item);
                }else if(item.type===4){ // 直播
                    if(item.contentId){
                        this.watchLivejump(item.contentId, item.status,item)
                    }else{
                        this.coursetxt='无内容，无法学习';
                        this.djscount=2;
                        this.courseshow=true;
                        return;
                    }
                }else if(item.type===5){ // 实训
                    this.coursetxt='线上实训无法在手机上进行，请前往电脑网页端';
                    this.djscount=2;
                    this.courseshow=true;
                    return;
                } else if(item.type===6){ // 表单
                    this.$router.push({
                        path:'/learning/formPage',
                        query:{
                            // type: this.$route.query.backType == 1 ? 2 : this.$route.query.backType == 2 ? 1 : null, // type：1训练营 2培训任务
                            type: 2,
                            typeId: this.$route.query.id, // typeId：训练营id或者培训任务id
                            wjId:item.contentId // wjId：问卷ID
                        }
                    });
                }else if(item.type === 7){ // 练习
                    this.$router.push({
                        path: '/testDetail',
                        query: {
                            businessId: item.taskId,
                            businessType: 2,
                            practiceId: item.contentId,
                            taskId: item.taskId,
                            taskType: 2,
                            backType: this.$route.query.backType || 1,
                            backPath: this.$route.query.backPath,
                            goodsId:this.$route.query.goodsId,
                            goodsKind:this.$route.query.goodsKind,
                        }
                    })
                }
            }else if(item.courseType || item.courseType === 0){ // 课程点击
                this.videoInfo.deadline = 0; // 视频当前可以拖动的时间
                // 切换之前保存记录，并重新获取目录
                this.nodeId = item.id;
                this.videoInfo.fastForward = false;
                console.log(this.currentlyPlay,'this.currentlyPlay')
                let video = document.querySelector('video') || document.querySelector('audio')
                if (item.courseType != 0 && video) {
                  await this.postCourseLearningLogSaveLog();
                  await this.postUserLearningLog();
                  if(this.Task_interface_optimize){
                    await this.taskDetailExt();
                  }else{
                    await this.getTaskDetail()
                  }
                  
                  // 
                }
                // 清除任务设置课程弹屏
                clearInterval(this.timeoutDialogAlert);
                // 清除 人脸识别定时器
                clearInterval(this.faceRecognizeTimer);
                this.clearTimer();
                if(item.contentId == this.courseId || (!this.courseId && typeof(this.courseId) != 'undefined')){
                    this.courseId = item.courseId;
                }
                // this.courseId = item.courseId;

                this.resourceId = item.detailId;
                this.WDuserInfo = JSON.parse(localStorage.getItem('WDuserInfo'));
                await this.getCourseInfo(item);
                if ( this.courseInfo.dateExpireStatus == 2) {
                    this.$notify({
                        type: "warning", message: "已过期不可查看",
                    });
                    return;
                }

                /**
                 * 解决下标问题
                 */
                const is = this.allresouce.some((item1, index) => {
                    if (item.id === item1.id) {
                        this.sourceId = index;
                        return false;
                    }
                })
                //  人脸识别 实名认证 点击资源
                if (+this.TrainBasicInfo.isCourseFaceRecognize === 1 && item.courseType) {
                    if (+this.WDuserInfo.idAuthStatus !== 1) {
                        let url = window.location.href + `&nodeId=${this.nodeId}`
                        localStorage.setItem('taskDetailUrl',url)
                        this.$router.push({
                            path:'/idcard',
                            // query:{
                            //     courseId: this.courseId,
                            //     trainId: this.$route.query.id || '',
                            //     studyProcess:this.studyProcess,
                            //     backType:this.$route.query.backType || 1,
                            //     taskType:2,
                            // }
                        }); // 跳转到实名认证
                        return;
                    }
                    
                }
                if([3, 4].includes(+item.courseType)){ // 文档 图片
                    this.goPDF(item)
                }else if ([1, 2].includes(+item.courseType)) {  // 视频
                   $(window).scrollTop(0);
                   await this.findCourseItemByCourseId(item)
                   await this.videoPlayClick(item);
                   if (!this.currentlyPlay.studyInfo) {
                    this.currentlyPlay.studyInfo = {};
                  }
                  if(item.id !== +this.$route.query.nodeId){
                      localStorage.setItem('faceidentify',0);
                      sessionStorage.setItem('videoEndFace',0)
                  }
                }else if(item.courseType === 10){ // 练习
                    this.userPracticejoinExam(item.detailId,item.courseId);
                }else if(item.courseType === 11){ // 直播
                    if(item.liveStatus == 0 || item.liveStatus == 1){ //
                        goLiveHome(this, item.liveRoomId,item)
                    } else {
                        this.$toast({
                            message:'直播已结束！',
                            duration: 3000,
                        });
                        return false
                    }
                }else if(item.courseType === 12){ // 实训
                    this.coursetxt='实训无法在手机上进行，请前往电脑网页端';
                    this.djscount=2;
                    this.courseshow=true;
                    return;
                }else if(item.courseType==6){
                    // scorm
                    this.$router.push({
                        path:'/learning/scrom',
                        query:{
                            resId:item.detailId,
                            taskId:this.$route.query.id || '',
                            courseId:item.courseId,
                            courseItemId:item.id,
                            name:item.contentName
                        }
                    })
                    return false
                }
            }
        },
        // 跳转文档 图片
        goPDF(item){
            this.$router.push({
              path: "/showPdf",
              query: {
                  id:item.detailId,
                  type:item.courseType,
                  courseId:item.courseId,
                  taskId: this.$route.query.id,
                  courseItemId: item.id,
                  pollingTime: 5,
                  name:item.contentName, // 文档名称
                  duration:item.duration, // 总页数
                  taskType:2,
                  backType:this.$route.path,
                  backPath: this.$route.query.backPath,
                  goodsId:this.$route.query.goodsId,
                  goodsKind:this.$route.query.goodsKind,
                  distributionUserId:this.$route.query.distributionUserId
              }
          })
        },
        /** 课程练习 */
        userPracticejoinExam(id,courseId){
            let params = {
                practiceId:id,
                businessType:3,
                businessId:courseId || '',
            };
            this.$api.exam.userPracticejoinExam({ params }).then(({ data }) => {
                this.$router.push({
                    path: "/testpage",
                    query: {
                        practiceId:id,
                        userPracticeId:data,
                        backType:this.$route.query.backType || 1,
                        trainId:this.$route.query.id,
                        courseId:this.courseId,
                        taskType:2,
                        backPath: this.$route.query.backPath,
                        goodsId:this.$route.query.goodsId,
                        goodsKind:this.$route.query.goodsKind,
                    }
                })
            });
        },
        /**
         * 课程倒计时弹窗
         */
        dialogAlert () {
                console.log('====================dialogAlert')
            console.log('isfacedialog',this.isfacedialog);

            this.timeoutDialogAlert = setInterval(() => {
                console.log('弹屏')
                // 弹屏之前存一下当前播放时间
                let video = document.querySelector('video')
                sessionStorage.setItem('currentVideoTime',video.currentTime)
                // 如果video 进入全屏状态则退出全屏
                if(this.checkIsFullScreen()){
                    this.exitFullscreen();
                }
                this.$refs.Aliplayer.player.pause();
                this.$dialog.alert({
                    confirmButtonText:'我在，继续学习',
                    className:'dialogAlert',
                    message: this.TrainBasicInfo.alertWindowTip || '亲爱的学员，还在吗？请不要走开，点击 ”我在“继续学习，否则您离开的时间将不计入学时',
                }).then(() => {
                    console.log('renlain========')
                    this.videoInfo.detect = true;
                    /** 点击我知道 重新给播放器赋值 */
                    this.$refs.Aliplayer.isVideoTime = true;
                    this.$refs.Aliplayer.player.seek(sessionStorage.getItem('currentVideoTime'));
                    clearInterval(this.timeoutDialogAlert)
                    this.dialogAlert();
                    /** 如果覆盖掉人脸识别弹窗，确定之后重新调起 */
                    if(this.isfacedialog){
                        this.$refs.facedialog.getConfirm()
                    }
                    // 如果正在人脸识别则不进行播放
                    if(!this.isfacedialog){
                      this.$refs.Aliplayer.player.play()
                    }

                })
                //解决只弹出一次确认弹窗的问题
                // this.clearTimeing();
                console.log(this.TrainBasicInfo.alertTime,'this.TrainBasicInfo.alertTime')
            }, (this.TrainBasicInfo.alertTime || 10) * 60000)
        },
        /**
         * 视频播放过程中设置人脸识别
        */
        setFaceRecognizeDialog(){
          let time = this.TrainBasicInfo.courseFaceRecognizeTime * 60 * 1000;
          this.faceRecognizeTimer = setInterval(() => {
              console.log('课程人脸识别')
              this.$refs.Aliplayer.player.pause()
              this.judgefaceauth(0)
          }, time)
        },
        //判断进入退出全屏
        checkIsFullScreen() {
          const isFullScreen = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen;
          return isFullScreen == undefined ? false : isFullScreen;
        },
        /**
         * video 退出全屏问题
         */
        exitFullscreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if(document.oRequestFullscreen){
                document.oCancelFullScreen();
            }else if (document.webkitExitFullscreen){
                document.webkitExitFullscreen();
            }
        },
        async getAccountUserInfo () {
            return this.$api.usercenter.getAccountUserInfo({}).then(res => {
                if (res.data) {
                    this.$store.state.userInfo = {
                        ...this.$store.state.userInfo,
                        ...res.data
                    }
                    localStorage.setItem('WDuserInfo', JSON.stringify(this.$store.state.userInfo))
                }
            })
        },
        /**
         * 播放进度实时获取
         */
        timeupdatePlay(){
            let video = document.querySelector('video')
            if (+this.currentlyPlay.type === 2 || +this.currentlyPlay.courseType === 2) {
                video = document.querySelector('audio')
            }
            let course_after_faceIdentification_time = +this.course_after_faceIdentification_time || 15;
            if( +sessionStorage.getItem('videoEndFace') !== 1 && (!this.currentlyPlay.studyInfo || (this.currentlyPlay.studyInfo.learnRate || 0) < 100)  && (video?.duration - video?.currentTime) < course_after_faceIdentification_time && this.task_course_after_faceIdentification && +this.TrainBasicInfo.isCourseFaceRecognize === 1){
                this.$refs.Aliplayer.player.pause();
                // 保存接口
                this.postCourseLearningLogSaveLog();
                this.postUserLearningLog();
                console.log('timeupdatePlay=====')
                this.judgefaceauth(2);
                return

            }
        },
        clearTimer(){
            if(this.IntervalName){
              clearInterval(this.IntervalName);
              this.IntervalName = null;
            }
            if(this.timeoutDialogAlert){
              clearInterval(this.timeoutDialogAlert);
              this.timeoutDialogAlert = null;
            }
            if(this.faceRecognizeTimer){
              clearInterval(this.faceRecognizeTimer);
              this.faceRecognizeTimer = null;
            }
        },
         /**
         * 开始播放
         * 先清除定时器在生成定时器，防止保存课程id不对
         */
        async startPlay(){
            $(window).scrollTop(0);
            // this.$forceUpdate();
            console.log('===开始播放====');
            this.clearTimer();
            await this.timing();
            console.log(this.currentlyPlay,'currentlyPlay');
            /** 解决iOS 13.4版本进度赋值问题 */
            // if(this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.playLength){
            //   setTimeout(() => {
            //     this.videoInfo.fastForward = false;
            //     if(+this.videoInfo.video.currentTime < this.currentlyPlay.studyInfo.playLength){
            //       if(this.currentlyPlay.studyInfo.playLength + 5 <= this.videoInfo.source.videoMeta?.duration || this.$refs.Aliplayer.player.getDuration()){
            //         this.videoInfo.video.currentTime = this.currentlyPlay.studyInfo.playLength;
            //       }else{
            //         this.videoInfo.video.currentTime = 0;
            //       }
            //     }
            //     // console.log(this.videoInfo.video,'currentTime====父组件play')
            //     console.log(this.videoInfo.video.currentTime,'currentTime====父组件play')
            //   },400)
            // }

            /**
             * isAlertWindow: 弹屏开启 1 开启 0 关闭
             * alertType: 弹屏类型 1 按次数 0 按时间
             * alertTime：弹屏时间
             */
            // console.log(this.TrainBasicInfo.alertType,'this.TrainBasicInfo.alertType',this.TrainBasicInfo.isAlertWindow,this.TrainBasicInfo.isAlertWindow && !this.TrainBasicInfo.alertType)
            if (
              this.TrainBasicInfo.isAlertWindow
              && !this.TrainBasicInfo.alertType
              && (!this.currentlyPlay.studyInfo || (this.currentlyPlay.studyInfo.learnRate || 0) < 100)
            ) {
                await this.dialogAlert()
            }
            /**
             * 视频观看过程中人脸识别
             * 是否开启人脸识别：isCourseFaceRecognize 1 是 0 否
             * 人脸识别间隔时间：courseFaceRecognizeTime
             * 当前进度小于 100
             * 设置人脸识别并且设置分钟
             * 如果设置了人脸识别并且视频进度小于100 或者第一次观看
             * faceidentify 1 人脸识别成功 0 失败
            */

            if(
              +this.TrainBasicInfo.isCourseFaceRecognize === 1
              && (!this.currentlyPlay.studyInfo || (this.currentlyPlay.studyInfo.learnRate || 0) < 100)
              ){
                console.log('人脸识别====')
              if (+localStorage.getItem("faceidentify") === 0){
                  // 人脸识别失败
                  console.log('人脸识别失败')
                  this.$refs.Aliplayer.player.pause()
                  this.judgefaceauth(1)
                }else if(this.isCloseFacedialog){
                  // 取消人脸识别弹窗
                  console.log('取消人脸识别弹窗')
                  this.$refs.Aliplayer.player.pause()
                  this.judgefaceauth(1)
              }else if( this.TrainBasicInfo.courseFaceRecognizeTime){
                    // 设置人脸识别间隔时间
                    console.log('设置人脸识别间隔时间')
                    this.setFaceRecognizeDialog()
                }
            }

            /**
             * 视频进度小于100 并 设置人脸识别
             *
             */
            // if (
            //     +localStorage.getItem("faceidentify") === 0
            //     && +this.TrainBasicInfo.isCourseFaceRecognize === 1
            //     && !this.currentlyPlay.studyInfo
            //     || (this.currentlyPlay.studyInfo && this.currentlyPlay.studyInfo.learnRate < 100)
            //   ) {
            //     this.$refs.Aliplayer.player.pause()
            //     this.judgefaceauth(1)
            //     return
            // }
            if (!this.videoInfo.detect) {
                this.$refs.Aliplayer.player.pause()
                return
            }
        },

        /**
         * 播放结束
         */
        async playEnd(){
            // 视频结束之后清除 弹屏 定时器
            clearInterval(this.timeoutDialogAlert);
            // 清除 人脸识别定时器
            clearInterval(this.faceRecognizeTimer);


            // 结束之后调取保存接口
            await this.postCourseLearningLogSaveLog();
            await this.postUserLearningLog();
            /**
             * 解决下标问题
             */
            const is = this.allresouce.some((item1, index) => {
                if (this.currentlyPlay.id === item1.id) {
                    this.sourceId = index;
                    return false;
                }
            })
            console.log('======视频播放结束====')
            if (this.endedStatue) {
                this.endedStatue = false
                this.clearTimeing();
                this.videoInfo.deadline = 0;
                this.sourceId = this.sourceId + 1;
                // 清除保存进度
                localStorage.removeItem('videoTime');
                /**
                 * 课程目录顺序播放
                 */
                console.log(this.sourceId,'sourceId')
                console.log(this.allresouce,'this.allresouce')
                if (this.sourceId < this.allresouce.length) {
                    this.currentlyPlay = this.allresouce[this.sourceId];
                    this.courseId = this.currentlyPlay.courseId;
                    this.nodeId = this.currentlyPlay.id;
                    if (!this.currentlyPlay.studyInfo) {
                      this.currentlyPlay.studyInfo = {};
                    }
                    this.videoPlayClick(this.currentlyPlay)
                    // // 重新获取目录
                    if(this.Task_interface_optimize){
                      await this.taskDetailExt();
                    }else{
                      await this.getTaskDetail()
                    }
                    // await this.findCourseItemByCourseId(0,true);

                } else {
                    /**
                     * 如果是培训任务 里面多个课程直接播放第二个课程
                     */
                    this.getNextCourseInfo()

                }
                setTimeout(() => {
                    this.endedStatue = true
                }, 300);
            }

        },
        /**
         * 播放暂停
         */
        async playPause(){
            /**
             * 清除保存接口定时器
             */
            await this.clearTimeing();
            console.log(this.timeoutDialogAlert,'timeoutDialogAlert');
            console.log(this.faceRecognizeTimer,'faceRecognizeTimer');
            console.log(this.IntervalName,'this.IntervalName')
        },
        /**
         * 清除定时器
         */
        async clearTimeing () {
            if (this.IntervalName) {
                clearInterval(this.IntervalName);
                this.IntervalName = null;
            }
        },
        /** 销毁播放器 */
        async playerDispose() {
            return new Promise((res, rej) => {
                try {
                    this.$refs.Aliplayer && this.$refs.Aliplayer.player && this.$refs.Aliplayer.player.dispose();
                    res(true);
                } catch (error) {
                    rej(error);
                }
            })
        },
        /**
         * 获取视频播放地址
         */
        async getPlayAuthToken (item) {
            const params = {
                resId: item.detailId
            }
            await this.$api.resource.getPlayAuthToken({ params }).then(res => {
                if(res.data){
                    this.videoInfo.source = res.data;
                }

            })
        },

        /**
         * 点击视频音频
         */
        async videoPlayClick(item){
            this.$nextTick(() => {
                this.currentlyPlay = item;
                this.courseId = item.courseId;
                this.resourceName = item.contentName;
                console.log(this.resourceName,'resourceName')
            })

            console.log(this.currentlyPlay,'currentlyPlay videoPlayClick')

            this.videoInfo.deadline = 0;
            await this.playerDispose().then(()=>{
            // 音频 和 视频 阿里配置
                return  this.getPlayAuthToken(item);
            })
            if (+item.courseType === 1) {
                this.videoInfo.videoType = {
                    format: 'm3u8',
                    mediaType: 'video'
                }
            } else {
                this.videoInfo.videoType = {
                    format: 'mp3',
                    mediaType: 'audio'
                }
            }
            const bool = (this.videoInfo?.source?.sourceSing && (this.videoInfo?.source?.sourceSing=='222' || this.videoInfo?.source?.sourceSing=='333'))?true:false;
            await this.$refs.Aliplayer.getAliplayer(this.videoInfo.source,bool, this.videoInfo);
        },
        /**
         * 获取任务里下一个课程
         */
        getNextCourseInfo(){
            let params = {
                courseId:this.courseId, // 当前课程ID
                taskId:this.$route.query.id, // 当前任务训练营ID
            }
            /**
             * courseId 当前课程id
             * nextCourseId 下一个课程id
             * nextCourseName  下一个课程名称
             * nextCourseNullType nextCourseId 为空时的原因类型，0 代表已全部学完，1 代表下一个课程未解锁
             */
            this.$api.course.getNextCourseInfo({params}).then(async (res) => {
                this.courseId = res.data.nextCourseId || res.data.courseId;
                await this.getCourseInfo()
                if(res.data.nextCourseNullType === 1 && !res.data.nextCourseId){
                    this.$toast({
                            message:'下一个课程未达到解锁规则，请按规则进行学习',
                            className:'courseToast'
                        });
                }else if(res.data.nextCourseNullType === 0 && !res.data.nextCourseId){
                    this.$toast({
                        message:'已经是最后一个内容了',
                        className:'courseToast'
                    });
                    // 重新获取目录
                    if(this.Task_interface_optimize){
                      await this.taskDetailWithoutLogin('end');
                    }else{
                      await this.getTaskDetail('end')
                    }
                }else {
                    this.allresouce = [];// 进来之前清空上一个课程所有资源
                    await this.findCourseItemByCourseId(0,true);
                    this.sourceId = 0;
                    console.log(this.allresouce.length,'this.allresouce.length')
                    if(this.allresouce.length){
                        this.currentlyPlay = this.allresouce[this.sourceId];
                        if(this.currentlyPlay?.studyInfo){
                            this.currentlyPlay.studyInfo.playLength = 0;
                        }
                        this.nodeId = this.currentlyPlay.id;
                        if (!this.currentlyPlay.studyInfo) {
                          this.currentlyPlay.studyInfo = {};
                        }
                        if(this.Task_interface_optimize){
                          await this.taskDetailExt();
                        }else{
                          await this.getTaskDetail()
                        }
                        await this.clickNode(this.currentlyPlay);
                    }

                    // this.videoPlayClick(this.currentlyPlay);
                }

            })
        },
        /**
         * 重新获取课程目录
         */
        eachReplaceKey(data) {
            let item=[];
            data.map((list)=>{
                let newData={
                    ...list,
                    contentName:list.name,
                    courseType:list.type,
                    childItemList:list.childrenList && list.childrenList.length && this.eachReplaceKey(list.childrenList) || [],
                    childrenList:null,
                    type:null,
                };

                item.push(newData);
            })
            return item;
        },
        async findCourseItemByCourseId(item,tag){
             this.allresouce = [];
            let params = {
                courseId: item && (item.courseId || item.contentId )|| this.courseId,
                taskId: this.$route.query.id,
                taskType:2
            }
            const { data } = await this.$api.course.findCourseItemByCourseId({ params });
            data.forEach(item => {
                item.level = 1;
            })
            let newArr =  this.eachReplaceKey(data,tag);
            // 扁平化 课程大纲
            await this.getAllavedio(newArr);


            // 重新获取目录使用
            if(tag && this.allresouce.length){
                console.log(this.currentlyPlay,'currentlyPlay')
                await this.changeArr(this.taskList,this.currentlyPlay,newArr);
                await this.familyTree(newArr,this.currentlyPlay.id);
            }
            // 点击课程 时使用
            if(item && !item.courseType){
                item.childItemList = newArr;
            }

        },
        /** 大纲目录遍历 */
        changeArr(data,item1,newArr){
            data.forEach(item => {
                if(item.contentId === item1.courseId){
                    item.childItemList = newArr;

                }
                if(item.childItemList && item.childItemList.length){
                    this.changeArr(item.childItemList,item1,newArr);

                }
            });
        },
        // 获取课程大纲目录中的所有资源文件
        async getAllavedio (data) {
            if (!data) {
                return;
            }
            data.forEach(item => {
                if (item.detailId && [1, 2].includes(+item.courseType)) {
                    this.allresouce.push(item)
                } else if (item.childItemList && item.childItemList.length > 0) {
                    return this.getAllavedio(item.childItemList)
                }
            })
        },
        // /** 遍历大纲 课程添加等级字段 */
        changeArr2(data){
            data.forEach(item => {
                if(item.type === 2){
                    // item.childItemList.forEach(childItem => {
                    //     childItem.level = 1;
                    // });
                    this.render(item.childItemList,0)
                }
                if(item.childItemList && item.childItemList.length){
                    this.changeArr2(item.childItemList);

                }
            });
        },
        render(arr,level){
            const that =this;
            var level=level||0;
            level++;
            var i= 0,len=arr.length;
            for(i=0;i<len;i++){
                if(arr[i].childItemList&&arr[i].childItemList.length>0){
                    arr[i].level = level;
                    that.render(arr[i].childItemList,level);
                }
            }
        },
        // 初始化任务详情
        async taskDetailWithoutLogin(type){
            let params = {
                id:this.$route.query.id,
                version:1,
            };
            await this.$api.learning.taskDetailWithoutLogin({params}).then(async res => {
                this.showLoading = false;
                if(!res.data && res.message === "用户尚未添加到该培训任务"){
                    this.$router.go(-1);
                    return false;
                }
                if(res.data){
                    this.taskInfo = res.data;
                    this.taskList=res.data.taskItemVoList || [];
                    await this.changeArr2(this.taskList);
                    console.log(this.taskList,'tasklist')
                    // 从商品或者人脸识别 过来需要展开节点
                    if(this.$route.query.nodeId || this.nodeId){
                       await this.familyTree(this.taskList, this.nodeId || +this.$route.query.nodeId,true,type);
                    }
                    /** 直播显示文案 */
                    res.data.taskItemVoList.length && res.data.taskItemVoList.forEach((item,index) => {
                        if(item.type == 4){
                            this.isHaveLive = true;
                        }
                    })

                    this.taskDetailExt();
                }
                console.log('res====任务详情',res)
            })
        },
        // /** 遍历大纲 返回学习相关信息 */
        changeTaskTree(data,data2){
            data.forEach(item => {
                data2.forEach(item2 => {
                  if(item.id === item2.id){
                      item2.studyProcess = item.studyProcess;
                      item2.studyInfo = item.studyInfo;
                  }
                  // 添加作业
                  if(item.homeworkId&&item.courseId === item2.contentId){
                      item2.childItemList.push(item)
                  }
                  if(item2.childItemList && item2.childItemList.length){
                      this.changeTaskTree(data,item2.childItemList);
                  }
                })
                if(item.childItemList && item.childItemList.length){
                    this.changeTaskTree(item.childItemList,data2);
                }
            });

        },
        // 二次渲染任务详情 返回学习
        taskDetailExt(){
          const params = {
              id:this.$route.query.id
          }
          this.$api.learning.taskDetailExt({params}).then(async res => {
              if(res.data){
                  this.taskInfo = {
                    ...this.taskInfo,
                    learnTotalTime:res.data.learnTotalTime,
                    courseNum:res.data.courseNum || 1,
                    studyProcess:res.data.studyProcess
                  };
                  let tree = [];
                  // const that = this;
                  for(let key in res.data.itemInfos){
                    tree.push(res.data.itemInfos[key])
                  }
                  await this.changeTaskTree(tree,this.taskList);
                  console.log('tree====',tree);
                  console.log('this.taskList',this.taskList)

              }
          })
        },
        /**
         * 获取任务详情数据
         */
        async getTaskDetail(type) {
            let params = {
                id:this.$route.query.id,
                version:1,
            };
            await this.$api.learning.taskDetail({ params }).then(async(res) => {
                this.showLoading = false;
                if(!res.data && res.message === "用户尚未添加到该培训任务"){
                    this.$router.go(-1);
                    return false;
                }
                if(res.data){
                    this.taskInfo = res.data;

                    this.taskList=res.data.taskItemVoList || [];
                    await this.changeArr2(this.taskList);
                    console.log(this.taskList,'tasklist')
                    // 从商品或者人脸识别 过来需要展开节点
                    if(this.$route.query.nodeId || this.nodeId){
                       await this.familyTree(this.taskList,this.nodeId || +this.$route.query.nodeId ,true,type);
                        // this.findCourseItemByCourseId()
                    }
                    /** 直播显示文案 */
                    res.data.taskItemVoList.length && res.data.taskItemVoList.forEach((item,index) => {
                        if(item.type == 4){
                            this.isHaveLive = true;
                        }
                    })
                    console.log(this.currentlyPlay,'===========')
                }
            });
        },
    },
    /**
     * 离开页面销毁定时器
     */
    destroyed () {
        clearInterval(this.IntervalName);
        clearInterval(this.timeoutDialogAlert);
        // 清除 人脸识别定时器
        clearInterval(this.faceRecognizeTimer);

        // 清除保存进度
        localStorage.removeItem('videoTime');
        this.playerDispose()

        localStorage.setItem('faceidentify', 0)
        sessionStorage.removeItem('videoEndFace')
        window.removeEventListener("popstate", this.goBack, false); //false阻止默认事件
    }
}
</script>
<style lang="less" src="../css/taskDetail.less" scoped>

</style>
